<template>
  <el-form
    v-form
    editAction="edit.action"
    addAction= 'add.action'
    :model="loginForm" label-width="125px" :rules="rules">
    <el-form-item label="姓名" prop="username">
      <el-input type="text" v-model="loginForm.username"></el-input>
    </el-form-item>
    <el-form-item label="电话" prop="phone">
      <el-input type="number" v-model="loginForm.phone"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" submit>保存</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data: function () {
    	return {
      loginForm: {
        id: null,
        username: null,
        phone: null
      },
      rules: {
        username: [
          {
            required: true,
            message: '用户名不能为空！',
            trigger: 'blur'
          }
        ],
        phone: [
          {
            required: true,
            message: '电话不能为空！',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created: function () {
    // 从外传递过来的id，如果id有值则证明此表单为编辑表单（非添加）
    let params = this.$route.params
    this.loginForm.id = params.id
  },
  methods: {
    onSelectInfo: function (dataInfo) {
      // TODO 完成表单回显查询钩子
    },
    onFilterParams: function (params) {
      // TODO 添加/修改表单前参数过滤钩子
    },
    onAdded: function (dataInfo) {
      // TODO 添加表单成功钩子
    },
    onEdited: function (dataInfo) {
      // TODO 修改表单成功钩子
    }
  }
}
</script>
